module.exports = __webpack_public_path__ + "img/homepage.7af20470.svg";